(function ($) {
	"use strict";
	let blockWheelsCountDown = {
		initAll: function () {

			const elementList = document.querySelectorAll('.wp-block-blockwheels-countdown');

			if (!elementList || elementList.length === 0) {
				return;
			}
			// Countdown Bar
			[...elementList].forEach((countdown) => {
				let countDownId = $(countdown).data('id'),
					dateTime 	= $(countdown).data('date-time'),
					days 		= $(countdown).data('days'),
					dl 			= $(countdown).data('dl'),
					hours 		= $(countdown).data('hours'),
					hl 			= $(countdown).data('hl'),
					minutes 	= $(countdown).data('minutes'),
					ml 			= $(countdown).data('ml'),
					seconds 	= $(countdown).data('seconds'),
					sl 			= $(countdown).data('sl'),
					dateFormat 	= '',
					dateLayout 	= '';

				if (days){
					dateFormat +='D';
					dateLayout +='<div class="blockwheels-countdown-item"><span class="blockwheels-countdown-number">{dn}</span><span class="blockwheels-countdown-label">{dl}</span></div>';
				}
				if (hours){
					dateFormat +='H';
					dateLayout +='<div class="blockwheels-countdown-item"><span class="blockwheels-countdown-number">{hn}</span><span class="blockwheels-countdown-label">{hl}</span></div>';
				}
				if (minutes){
					dateFormat +='M';
					dateLayout +='<div class="blockwheels-countdown-item"><span class="blockwheels-countdown-number">{mn}</span><span class="blockwheels-countdown-label">{ml}</span></div>';
				}
				if (seconds){
					dateFormat +='S';
					dateLayout +='<div class="blockwheels-countdown-item"><span class="blockwheels-countdown-number">{sn}</span><span class="blockwheels-countdown-label">{sl}</span></div>';
				}
				
				$(`#countdown-${countDownId}`).countdown({
					until: dateTime,
					format: dateFormat,
					labels: ['Years', 'Months', 'Weeks', dl, hl, ml, sl],
					labels1: ['Year', 'Month', 'Week', dl, hl, ml, sl],
					layout: dateLayout
				});
			});
		},
		// Initiate the menus when the DOM loads.
		init: function () {
			blockWheelsCountDown.initAll();
		},
	};
	if (document.readyState === "loading") {
		// The DOM has not yet been loaded.
		document.addEventListener("DOMContentLoaded", blockWheelsCountDown.init);
	} else {
		// The DOM has already been loaded.
		blockWheelsCountDown.init();
	}
})(jQuery);